import axios from 'axios';
import { API_BASE_URL, API_URLS } from '../config/constants';

const userLogService = {
  // Get all user logs with filters
  getAllLogs: async (params = {}) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.USER_LOGS}`, { 
        params: {
          page: params.page || 1,
          per_page: params.per_page || 15,
          ...params
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get user log by ID
  getLogById: async (logId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.USER_LOG_BY_ID(logId)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get user log statistics
  getLogStats: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.USER_LOG_STATS}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

export default userLogService;